import React from "react";

export default function Logo({ size = 28, className = "", variant = "default" }) {
  const src = variant === "red" ? "/athlon-logo-red.png" : "/athlon-logo.png";
  return (
    <img
      src={src}
      alt="Athlon Sports"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: "contain" }}
    />
  );
}
